import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selectCalendarDate } from '@shared/store/dashboard.duck';
import { selectCurrentUser } from '@shared/store/auth.duck';
import WhereaboutsRow from "./movements-wallchart/components/user-row/WhereaboutsRow";
import { Accordian } from '@shared/animations/AnimationVariants';
import {
  loadCurrentUsersWhereabouts,
  selectCurrentUsersWhereabouts
} from "@features/whereabouts/pages/team-movements/models/team-movements.duck";
import styled from "styled-components";
import { smallTablet } from "../atoms/MediaQueries";
import { WhereaboutsGroupType } from '@features/whereabouts/models/movements.models';

export function CurrentUsersWeeklyWhereabouts(props: Props) {
  const calendarDate = useSelector(selectCalendarDate);
  const currentUser = useSelector(selectCurrentUser);
  const currentUsersWeeklyWhereabouts = useSelector(selectCurrentUsersWhereabouts);
  const dispatch = useDispatch();

  useEffect(() => {
    if (calendarDate && currentUser) {
      dispatch(loadCurrentUsersWhereabouts({calendarDate: calendarDate}));
    }
  }, [currentUser, calendarDate, dispatch]);

  return (
    <Wrapper style={{...props.style ?? {}, width: '100%'}}>
      <Accordian isOpen={!!currentUsersWeeklyWhereabouts}>
        {currentUsersWeeklyWhereabouts && <WhereaboutsRow member={currentUsersWeeklyWhereabouts}
                                                          enableSetMovements={true}
                                                          currentUser={currentUser}
                                                          groupId={WhereaboutsGroupType.Users} />}
      </Accordian>
    </Wrapper>
  )
}

interface Props {
  style?: any;
}

const Wrapper = styled.div`
  .userAvatarAndName {
    margin-top: 16px;
  }
  @media (${smallTablet}) {
    .userAvatarAndName {
      margin-top: 8px;
    }
  }
`
